var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.online)?_c('ErrorView',{staticStyle:{"height":"100vh"},attrs:{"message":"Your connection is offline"}}):[_c('state-change-overlay'),_c('propose-challenge-change-overlay'),_c('router-view')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }